/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('modules/editor/editor',['require','jquery','underscore','backbone','marionette','core/templates','jqueryui','jsonEditor'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  //var _ = require('underscore');
  var underscore = require('underscore');
  var Backbone = require('backbone');
  var Marionette = require('marionette');
  var templates = require('core/templates');

  //require('marked');
  require('jqueryui');
  require('jsonEditor');

  /*****************************************************************************************************************///}

  var Editor = Marionette.Module.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    element: null,
    object: null,
    settings: null,
    visible: false,
    editor: null,
    radio: null,
    apiURL: '',

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    onStart: function(options)
    {
      this.settings = options.modules.editor;

      if (!this.settings.enabled)
        return;

      //console.log('Editor::start');
      ////console.log(options);

      var JSONEditor = window.JSONEditor;

      window._ = underscore;

      JSONEditor.defaults.options['theme'] = 'bootstrap3';
      JSONEditor.defaults.options['iconlib'] = 'bootstrap3';
      JSONEditor.defaults.options['form_name_root'] = 'page';
      JSONEditor.defaults.options['ajax'] = true;
      JSONEditor.defaults.options.template = 'underscore';
      //JSONEditor.defaults.editors.object.options.collapsed = true;
      //JSONEditor.defaults.editors.markdown.options['expand_height'] = true;
      ////console.log(JSONEditor.defaults.editors);

      //JSONEditor.plugins.epiceditor.basePath = '../bower_components/EpicEditor/epiceditor';

      this.element = $(templates['modules/editor/editor']());
      this.editorContent = this.element.find('.editor-content')[0];

      if (!this.visible)
        this.element.hide();

      $('body').append(this.element);

      this.element.draggable({ cursor: 'move' });//.resizable();

      this.apiURL = (window.location.port !== '8000') ? this.settings.apiURL : this.settings.localURL;

      this.radio = Backbone.Wreqr.radio.channel('global').vent;

      this.registerKeyPress();

      this.listenTo(this.app, 'page.loaded', function(object)
      {
        this.object = object;

        this.updateEditor();
      });
    },

    registerKeyPress: function()
    {
      var self = this;

      $(document).keydown(function(e)
      {
        switch (e.keyCode)
        {
          case 192:
          case 223:
            self.toggle();
            break;

          default:
            break;
        }
      });
    },

    toggle: function()
    {
      ////console.log('Editor::toggle');

      this.visible = !this.visible;
      this.element.toggle(this.visible);
    },

    updateEditor: function()
    {
      ////console.log('Editor::updateEditor');

      // set initial state as collapsed
      this.object.get('schema').options = { collapsed: true };

      if (this.editor)
        this.editor.destroy();

      $(this.editorContent).empty();

      var options = { };
      options.schema = this.object.get('schema');
      options.startval = this.object.get('data').toJSON();

      this.editor = new window.JSONEditor(this.editorContent, options);

      //var self = this;
      this.editor.on('ready', function()
      {
        ////console.log('JSON Editor: Ready');
        //self.editor.setValue(options.startval);
      });

      this.editor.on('change', $.proxy(this.updateData, this));
    },

    updateData: function(e)
    {
      ////console.log('Editor::updateData');

      var errors = this.editor.validate();

      if (errors.length)
      {
        console.warn('JSON Validation Error: ', errors);
        return;
      }

      var newData = this.editor.getValue();

      this.object.get('data').set(newData);

      var saveData = { };
      saveData.filename = '../../' + this.settings.contentFolder + this.object.id + '.json';
      saveData.data = JSON.stringify(newData, null, 2);

      this.save(saveData);
    },

    save: function(data)
    {
      ////console.log('Editor::save');

      $.ajax(this.apiURL, {
        cache: false,
        method: 'POST',
        data: data
      })
      .done(function(response)
      {
        ////console.log(response);
        // decode JSON response
        var result = '';
        try
        {
          result = JSON.parse(response);
        }
        catch (err)
        {
          result = {
            success: false,
            message: 'Error: Invalid JSON format.'
          };
        }

        //console.log(result.message);
      });
    }

  /*****************************************************************************************************************///}

  });

  return Editor;

});

